import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Fires an OpenAI oaiq PageView whenever the SPA route changes.
 * Must be rendered INSIDE a <BrowserRouter>.
 */
export default function OaiqRouteTracker() {
  const location = useLocation();

  useEffect(() => {
    if (typeof window === "undefined" || typeof window.oaiq !== "function") return;
    try {
      window.oaiq("track", "PageView");
    } catch {
      /* ignore */
    }
  }, [location.pathname, location.search]);

  return null;
}
